import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { keyMenu, marginX } from '../../../constants'
import { openModalDropdown } from '../../../redux/modalDropDownSlice'

const HeaderSearch = ({ keyword = '' }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const searchAgainHandler = () => {
    dispatch(openModalDropdown(keyMenu.search))
  }

  return (
    <Box style={styles.container}>
      <Typography
        onClick={searchAgainHandler}
        fontWeight="500"
        fontSize="1.4rem"
        style={styles.textUnderline}
        component="div"
        textAlign="right"
        color={'baseColor.colorText1'}>
        {t('actions.search_again')}
      </Typography>
      <Box>
        <Typography
          fontSize="2rem"
          lineHeight="2.4rem"
          component="h4"
          fontWeight="400"
          color={'baseColor.colorText1'}>
          {t('titles.search_result')}:
        </Typography>
        <Typography
          fontWeight="600"
          lineHeight="4.4rem"
          fontSize="3.6rem"
          component="h1"
          color={'baseColor.colorText1'}>
          “{keyword}”
        </Typography>
      </Box>
    </Box>
  )
}

export default React.memo(HeaderSearch)

HeaderSearch.propTypes = {
  keyword: PropTypes.string,
}

const styles = {
  container: {
    backgroundColor: 'baseColor.color1',
    padding: `16px ${marginX}px`,
  },
  textUnderline: { textDecoration: 'underline' },
}
